import(/* webpackMode: "eager" */ "/app/app/editor-v2/[toolId]/page.tsx");
